import React from 'react';
import '../App.css';
import 'latex.css/dist/style.css';  

const CustomLink = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="gold-link">
    {children}
  </a>
);

export default CustomLink;
